import React from 'react';
import { useMutation } from '@apollo/client';
import { GET_CUSTOMER, GET_ACTION_ITEMS, GET_CUSTOMER_TICKETS } from '../../Customers/graphql/queries';
import useNotification from '../../../Notifications/useNotifications';
import { CREATE_GIFT_VOUCHER } from '../graphql/mutations';
import { GiftVoucherInput } from '../type';
import GiftVoucherForm from '../GiftVoucherForm/GiftVoucherForm';
import { useNavigate, useParams } from 'react-router';

const NewGiftVoucher = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const { addSuccess, addError } = useNotification();

  const [createGiftVoucher] = useMutation(CREATE_GIFT_VOUCHER, {
    refetchQueries: [
      { query: GET_CUSTOMER, variables: { id } },
      { query: GET_ACTION_ITEMS },
      { query: GET_CUSTOMER_TICKETS, variables: { customerId: id } }
    ],
    awaitRefetchQueries: true,
    onCompleted: ({ createGiftCard }) => {
      if (createGiftCard) {
        addSuccess('New gift voucher created successfully');
        navigate(`/customers/details/${id}`);
      } else {
        addError('Error creating gift voucher. Please try again.');
      }
    },
    onError: (error) => addError(error.message)
  });

  const onSubmit = async (input: GiftVoucherInput) => {
    const values = {
      customerId: id,
      amount: input.amount,
      code: input.code
    };
    await createGiftVoucher({ variables: { values } });
  };

  return (
    <>
      <>
        <h1 className="my-6 text-3xl">New gift voucher</h1>
        <GiftVoucherForm onSubmit={onSubmit} />
      </>
    </>
  );
};

export default NewGiftVoucher;
